import { formatDate } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  ActionSheetController,
  AlertController,
  IonModal,
  LoadingController,
  ModalController,
  ToastController,
} from '@ionic/angular';
import { OverlayEventDetail } from '@ionic/core/components';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/app/auth/auth.service';
import { DogService } from '../dogs.service';
import { AddDogDTO, UpdateDogDTO } from '../mydogs.dto';
import { Capacitor } from '@capacitor/core';
import { Camera, CameraResultType, CameraSource } from '@capacitor/camera';
import { ImageCropperComponent } from 'src/app/shared/image-cropper/image-cropper.component';
import { HttpClient } from '@angular/common/http';
import { BreedListComponent } from 'src/app/breeds-info/breed-list/breed-list.component';

@Component({
  selector: 'app-addit-dog',
  templateUrl: './addit-dog.page.html',
  styleUrls: ['./addit-dog.page.scss'],
})
export class AdditDogPage implements OnInit, OnDestroy {
  @ViewChild('dobpopup') dobModal: IonModal;
  @ViewChild('breedpopup') breedModal: IonModal;
  isActionSheetOpen = false;
  showImage = false;
  imageSrc = 'https://freesvg.org/img/DogProfile.png';
  uploadedImage: string = '';

  viewImage() {
    this.showImage = true;
  }
  closeImage() {
    this.showImage = false;
  }
  async setOpen() {
    const hasImage =
      this.uploadedImage != 'https://freesvg.org/img/DogProfile.png' &&
      this.uploadedImage != '';
    const actionSheetButtons = [
      ...(hasImage
        ? [
          {
            text: 'View Picture',
            icon: 'eye-outline',
            disabled: true,
            handler: () => {
              this.viewImage();
            },
          },
        ]
        : []),
      {
        text: 'Choose from gallery',
        icon: 'image-outline',
        handler: () => {
          this.onPickImageFromCamera('Gallery');
        },
      },
      {
        text: 'Take new picture',
        icon: 'camera-outline',
        handler: () => {
          this.onPickImageFromCamera('Camera');
        },
      },
      ...(hasImage
        ? [
          {
            text: 'Remove current picture',
            icon: 'trash-outline',
            handler: () => {
              this.uploadedImage = this.imageSrc;
            },
            cssClass: 'danger-button',
          },
        ]
        : []),
    ];
    const actionSheet = await this.actionSheetCtrl.create({
      buttons: actionSheetButtons,
    });

    await actionSheet.present();
  }

  title = 'Add New Pet';
  isLoading = true;
  name: string;
  dob: string;
  dobPopupVal: Date;
  gender: string;
  breed: string;
  dateToday: string;
  isCastrated: boolean = false;
  dogId = 0;
  userId: number;
  addSub: Subscription;
  updateSub: Subscription;
  getSub: Subscription;
  userSub: Subscription;
  dogBreedsList = [];
  catBreedsList = [];
  breedSubscription: Subscription;
  petType: string = '1'; // Default to Dog
  constructor(
    private activatedRoute: ActivatedRoute,
    private dogService: DogService,
    private authService: AuthService,
    private alertCtrl: AlertController,
    private loadingCtrl: LoadingController,
    private toastController: ToastController,
    private router: Router,
    private modalCtrl: ModalController,
    private http: HttpClient,
    private actionSheetCtrl: ActionSheetController
  ) { }
  ngOnInit() {
    this.http.get<any[]>('assets/dog_breeds.json').subscribe(data => {
      this.dogBreedsList = data;
    });
    this.http.get<any[]>('assets/cat_breeds.json').subscribe(data => {
      this.catBreedsList = data;
    });
  }
  ionViewWillEnter() {
    this.dateToday = new Date().toISOString();
    this.userSub = this.authService.user.subscribe((user) => {
      if (user) {
        this.userId = user.id;
      }
    });
    this.dogId = +this.activatedRoute.snapshot.params.id;
    if (this.dogId > 0) {
      this.title = 'Edit';
      this.getSub = this.dogService.getDogById(this.dogId).subscribe((dog) => {
        this.name = dog.name;
        this.breed = dog.breed;
        this.gender = dog.gender;
        this.petType = dog.petTypeId.toString();
        const format = 'dd/MM/yyyy';
        const locale = 'en-US';
        this.dob = formatDate(dog.dateOfBirth, format, locale);
        this.dobPopupVal = dog.dateOfBirth;
        this.isCastrated = dog.isCastrated;
        this.title = `Edit ${this.name}'s Info`;
        this.isLoading = false;
        if (dog.imageUrl.length > 0) {
          this.uploadedImage = dog.imageUrl;
        } else {
          this.uploadedImage = this.imageSrc;
        }
      });
    } else {
      this.title = 'Add New Pet';
      this.isLoading = false;
      this.uploadedImage = this.imageSrc;
    }
  }

  selectBreed() {
    this.modalCtrl
      .create({
        component: BreedListComponent,
        componentProps: { breedsList: this.petType === '1' ? this.dogBreedsList : this.catBreedsList },
      })
      .then((modalEl) => {
        modalEl.present();
        return modalEl.onDidDismiss();
      })
      .then((resData) => {
        if (resData.role === 'select') {
          const breedId = resData.data.breedId;
          if (this.petType === '1') {
            const index = this.dogBreedsList.findIndex((b) => b.id === breedId);
            const listItem = this.dogBreedsList[index];
            this.breed = listItem.name;
          }
          else {
            const index = this.catBreedsList.findIndex((b) => b.id === breedId);
            const listItem = this.catBreedsList[index];
            this.breed = listItem.name;
          }
        }
      });
  }

  setGender(event: any) {
    this.gender = event.detail.value;
  }

  setPetType(event: any) {
    this.petType = event.detail.value;
  }
  ngOnDestroy() {
    if (this.addSub) {
      this.addSub.unsubscribe();
    }
    if (this.userSub) {
      this.userSub.unsubscribe();
    }
    if (this.updateSub) {
      this.updateSub.unsubscribe();
    }
    if (this.getSub) {
      this.getSub.unsubscribe();
    }
    if (this.breedSubscription) {
      this.breedSubscription.unsubscribe();
    }
  }

  cancelDOB() {
    this.dobModal.dismiss(null, 'cancel');
  }

  setDOB() {
    this.dobModal.dismiss(this.dobPopupVal, 'confirm');
  }

  onDOBWillDismiss(event: Event) {
    const ev = event as CustomEvent<OverlayEventDetail<string>>;
    if (ev.detail.role === 'confirm') {
      let myDate;
      if (ev.detail.data) {
        myDate = ev.detail.data;
      } else {
        myDate = new Date().toISOString();
      }
      const format = 'dd/MM/yyyy';
      const locale = 'en-US';
      this.dob = formatDate(myDate, format, locale);
    }
  }

  async onPickImageFromCamera(from: string) {
    if (!Capacitor.isPluginAvailable('Camera')) {
      return;
    }
    let source: any;
    if (from === 'Camera') {
      source = CameraSource.Camera;
    } else {
      source = CameraSource.Photos;
    }

    Camera.getPhoto({
      quality: 70,
      source,
      correctOrientation: true,
      resultType: CameraResultType.Base64,
      allowEditing: false,
    })
      .then((image) => {
        this.openImageCropper(image.base64String);
      })
      .catch((err) => { });
  }

  openImageCropper(imagebase64String) {
    this.modalCtrl
      .create({
        component: ImageCropperComponent,
        componentProps: {
          uploadedImage: 'data:image/jpeg;base64, ' + imagebase64String,
        },
      })
      .then((modalEl) => {
        modalEl.onDidDismiss().then((modalData) => {
          if (!modalData.data) {
            return;
          }
          this.uploadedImage = modalData.data['imageUrl'];
        });
        modalEl.present();
      });
  }

  save() {
    this.loadingCtrl
      .create({
        keyboardClose: true,
        message: 'Please wait...',
      })
      .then(async (loadingEl) => {
        loadingEl.present();
        if (this.dogId > 0) {
          const updateDogDTO: UpdateDogDTO = {
            name: this.name,
            breed: this.breed,
            petTypeId: +this.petType,
            dateOfBirth: this.dob,
            gender: this.gender,
            imageUrl: this.uploadedImage,
            isCastrated: this.isCastrated,
            id: this.dogId,
          };
          this.updateSub = (
            await this.dogService.updateDog(updateDogDTO)
          ).subscribe({
            next: async (res) => {
              if (!res) {
                loadingEl.dismiss();
                this.alertCtrl
                  .create({
                    header: 'An Error Occurred',
                    message:
                      'Could not perform this action at the moment. Please try again later.',
                    buttons: [{ text: 'Dismiss' }],
                  })
                  .then((alerEl) => {
                    alerEl.present();
                  });
              } else {
                const toast = await this.toastController.create({
                  color: 'primary',
                  duration: 2000,
                  message: 'Updated successfully',
                });
                loadingEl.dismiss();
                await toast.present();
                this.router.navigate(['account', 'mydogs']);
              }
            },
            error: () => loadingEl.dismiss(),
          });
        } else {
          const addDogDTO: AddDogDTO = {
            name: this.name,
            breed: this.breed,
            petTypeId: +this.petType,
            dateOfBirth: this.dob,
            gender: this.gender,
            userId: this.userId,
            imageUrl: this.uploadedImage,
            isCastrated: this.isCastrated,
          };
          this.addSub = (await this.dogService.addDog(addDogDTO)).subscribe({
            next: async (res) => {
              if (!res.isDogAdded) {
                loadingEl.dismiss();
                this.alertCtrl
                  .create({
                    header: 'An Error Occurred',
                    message:
                      'Could not perform this action at the moment. Please try again later.',
                    buttons: [{ text: 'Dismiss' }],
                  })
                  .then((alerEl) => {
                    alerEl.present();
                  });
              } else {
                const toast = await this.toastController.create({
                  color: 'primary',
                  duration: 2000,
                  message: 'Added successfully',
                });
                loadingEl.dismiss();
                await toast.present();
                if (
                  this.activatedRoute.snapshot.queryParamMap.get(
                    'fromReminder'
                  ) === '1'
                ) {
                  this.router.navigateByUrl(
                    '/reminders/addit-reminders?addedDogId=' + res.dogId
                  );
                } else {
                  this.router.navigate(['account', 'mydogs']);
                }
              }
            },
            error: () => loadingEl.dismiss(),
          });
        }
      });
  }

  deleteDog() {
    this.alertCtrl
      .create({
        header: 'Delete Pet?',
        message:
          'This action will delete related reminders and cannot be undone! Are you sure you want to delete this pet?',
        buttons: [
          {
            text: 'Cancel',
            handler: () => {
              this.alertCtrl.dismiss();
            },
          },
          {
            text: 'Delete',
            cssClass: 'confirm-delete',
            handler: () => {
              this.performDelete();
              this.alertCtrl.dismiss();
            },
          },
        ],
      })
      .then((alertEl) => alertEl.present());
  }

  performDelete() {
    this.loadingCtrl
      .create({
        keyboardClose: true,
        message: 'Please wait...',
      })
      .then((loadingEl) => {
        loadingEl.present();
        this.dogService.deleteDog(this.dogId).subscribe({
          next: async (res) => {
            const toast = await this.toastController.create({
              color: 'primary',
              duration: 2000,
              message: 'Deleted successfully.',
            });
            loadingEl.dismiss();
            await toast.present();
            this.router.navigate(['account', 'mydogs']);
          },
          error: async () => {
            loadingEl.dismiss();
            const toast = await this.toastController.create({
              color: 'danger',
              duration: 2000,
              message: 'Could not perform action. Please try again later.',
            });
            await toast.present();
          },
        });
      });
  }
}
